import React, { useEffect } from 'react';
import DashboardContainer from 'containers/dashboard/DashboardContainer';
import AppTemplate from 'components/base/template/AppTemplate';
import AppNav from 'components/base/nav/AppNav';
import { useShallowAppSelector } from 'store/hooks';
import { isLogInSelector } from 'store/modules/auth';
import storage from 'lib/storage';
import { useHistory } from 'react-router-dom';
import QuickStartContainer from 'containers/quickstart/QuickStartContainer';
import { ProjectProvider } from 'contexts/project/ProjectContext';

function QuickStart() {
  return (
    <AppTemplate
      title={'Quick Start'}
      leftSide={<AppNav />}
      mainStyle={{
        // padding: '0 50px',
        padding: '0 0 0 40px',
      }}
    >
      <ProjectProvider>
        <QuickStartContainer />
      </ProjectProvider>
    </AppTemplate>
  );
}

export default QuickStart;
